import React from 'react';
import PropTypes from 'prop-types';
import spinner from './img/loader.svg';
import styles from './LoadingPage.module.css';

const sizes = {
  s: styles.s,
  m: styles.m,
  l: styles.l,
  xl: styles.xl,
  xxl: styles.xxl,
};

const LoadingPage = ({ size }) => (
  <div className={styles.LoadingPage}>
    <img className={sizes[size]} src={spinner} alt="loading..." />
  </div>
);

LoadingPage.propTypes = {
  size: PropTypes.string,
};

LoadingPage.defaultProps = {
  size: 'm',
};

export default LoadingPage;
